import { mutate } from "swr";

import { type Appointment } from "../appointment/types";
import * as fetcher from "../fetcher";
import { mutateWithStartKey } from "../mutateWithStartKey";
import { type Task } from "../task/types";
import { getDropInAppointment } from "./utils";

export const createDropInAppointments = async (
  task: Partial<Task>,
  countryCode: string,
  mutateSearchAppointments?: () => void
) => {
  const taskData = getDropInAppointment(task, countryCode);
  const res = await fetcher.core.post("/opportunities/appointment", taskData);
  if (mutateSearchAppointments) {
    mutateSearchAppointments();
  }
  mutate(`/opportunities/${task.opportunityId}/history`);
  mutate(`/${task.opportunityId}/appointments`);

  return await res;
};

export const updateDropInAppointments = async (
  dropInAppointment: Appointment,
  mutateSearchAppointments?: () => void
): Promise<Appointment> => {
  const res = await fetcher.core.update(
    `/opportunities/appointments/${dropInAppointment.id}`,
    dropInAppointment
  );
  if (mutateSearchAppointments) {
    mutateSearchAppointments();
  }
  mutate(`/opportunities/${dropInAppointment.opportunityId}/history`);
  mutate(`/${dropInAppointment.opportunityId}/appointments`);
  mutate(`/appointments/${dropInAppointment.id}/opportunity`);
  mutateWithStartKey(`/calendar`);
  mutateWithStartKey(`/opportunities/appointments`);

  return (await res.json()) as Appointment;
};

export const deleteDropInAppointment = async (
  dropInAppointmentId: string,
  opportunityId?: number,
  mutateSearchAppointments?: () => void
) => {
  const res = await fetcher.core.remove(
    `/opportunities/appointments/${dropInAppointmentId}`
  );
  if (mutateSearchAppointments) {
    mutateSearchAppointments();
  }
  mutate(`/appointments/${dropInAppointmentId}/opportunity`);
  if (opportunityId) {
    mutate(`/opportunities/${opportunityId}/history`);
    mutate(`/${opportunityId}/appointments`);
  }

  return res;
};
